import Chatbot from "./Chatbot";
import ChatbotFloatingButton from "./ChatbotFloatingButton";
import { styled } from "@mui/material";
import clsx from "clsx";
import { useToggle } from "hooks/useToggle";
import { useCallback } from "react";

const TOTAL_CHAT_HEIGHT = 525;

const ContainerStyled = styled("div")(({ theme }) => ({
  position: "fixed",
  bottom: "1.5rem",
  right: "1.5rem",
  zIndex: theme.zIndex.chatbot,
  fontSize: "14px",
  "& .floating-button-container": {
    position: "relative",
  },
  "& .chatbot-container": {
    position: "absolute",
    top: `-${TOTAL_CHAT_HEIGHT + 10}px`,
    right: 0,
    height: `${TOTAL_CHAT_HEIGHT}px`,
    width: "400px",
    zIndex: theme.zIndex.chatbot,
    "&.minimized": {
      display: "none",
    },
  },
  [theme.breakpoints.down("md")]: {
    bottom: "4rem",
  },
}));

const ChatbotContainer = () => {
  const { isOpen: isDisplayed, toggle: toggleMinimized } = useToggle();
  const {
    isOpen: isChatMounted,
    open: mountChat,
    close: unmountChat,
  } = useToggle(false);

  const handleTerminate = useCallback(() => {
    unmountChat();
    toggleMinimized();
  }, [unmountChat, toggleMinimized]);

  const handleToggleChat = useCallback(() => {
    if (!isChatMounted) {
      mountChat();
    }
    toggleMinimized();
  }, [toggleMinimized, mountChat, isChatMounted]);

  return (
    <ContainerStyled>
      <ChatbotFloatingButton
        className="floating-button-container"
        onClick={handleToggleChat}
      >
        <div className={clsx("chatbot-container", { minimized: !isDisplayed })}>
          {isChatMounted && (
            <Chatbot
              toggleMinimized={toggleMinimized}
              onTerminate={handleTerminate}
            />
          )}
        </div>
      </ChatbotFloatingButton>
    </ContainerStyled>
  );
};

export default ChatbotContainer;
